export default __webpack_public_path__ + "static/media/transforming-btn.0b088efc.svg";